
import { useEffect, useState } from "react";
const CHECKS = [
    "ID & Biometrics Check",
    "Active / Suspended License",
    "Criminal Record Check",
    "Motor Vehicle Reports",
    "Driver Insurance Validation",
];
/* Cycles the verification checks one at a time beneath the heading, fading each
   phrase in and out. Respects prefers-reduced-motion by simply swapping text. */
export function RotatingChecks() {
    const [index, setIndex] = useState(0);
    const [visible, setVisible] = useState(true);
    useEffect(() => {
        const media = window.matchMedia("(prefers-reduced-motion: reduce)");
        if (media.matches) {
            const swap = setInterval(() => setIndex((i) => (i + 1) % CHECKS.length), 2500);
            return () => clearInterval(swap);
        }
        // Fade out, swap, fade back in.
        const cycle = setInterval(() => {
            setVisible(false);
            const swap = setTimeout(() => {
                setIndex((i) => (i + 1) % CHECKS.length);
                setVisible(true);
            }, 400);
            return () => clearTimeout(swap);
        }, 2500);
        return () => clearInterval(cycle);
    }, []);
    return (<div className="mt-5 flex items-center gap-3 lg:min-h-[4.75rem]" aria-live="polite">
      <span aria-hidden="true" className="h-2 w-2 shrink-0 rounded-full bg-[#3CC6F4] shadow-[0_0_12px_2px_rgba(60,198,244,0.6)]"/>
      <span className={`font-sans text-2xl font-medium tracking-tight text-white transition-all duration-[400ms] ease-out sm:text-3xl ${visible ? "translate-y-0 opacity-100" : "translate-y-1 opacity-0"}`}>
        {CHECKS[index]}
      </span>
    </div>);
}
